import Hammer from 'hammerjs';
import React, { useEffect, useRef } from 'react';
import pt from 'prop-types';

export const SwipeChannelSwitch = React.memo(
  ({ swipeAreaElement, toNextChannel, toPrevChannel }) => {
    const toNextChannelRef = useRef(toNextChannel);
    const toPrevChannelRef = useRef(toPrevChannel);

    useEffect(() => {
      toNextChannelRef.current = toNextChannel;
      toPrevChannelRef.current = toPrevChannel;
    }, [toNextChannel, toPrevChannel]);

    useEffect(() => {
      function onSwipe({ type }) {
        if (type === 'swipeleft') {
          toNextChannelRef.current();
        } else if (type === 'swiperight') {
          toPrevChannelRef.current();
        }
      }

      let hammer;
      if (swipeAreaElement) {
        hammer = new Hammer(swipeAreaElement);
        // disable all unnecessary gestures
        hammer.get('tap').set({ enable: false });
        hammer.get('doubletap').set({ enable: false });
        hammer.get('pan').set({ enable: false });
        hammer.get('press').set({ enable: false });
        hammer.get('pinch').set({ enable: false });
        hammer.get('rotate').set({ enable: false });

        hammer.on('swipeleft', onSwipe);
        hammer.on('swiperight', onSwipe);
      }
      return () => {
        if (hammer) {
          hammer.off('swipeleft', onSwipe);
          hammer.off('swiperight', onSwipe);
          hammer.destroy();
        }
      };
    }, [swipeAreaElement]);
  }
);

SwipeChannelSwitch.displayName = 'SwipeChannelSwitch';
SwipeChannelSwitch.propTypes = {
  swipeAreaElement: pt.instanceOf(HTMLDivElement).isRequired,
  toNextChannel: pt.func.isRequired,
  toPrevChannel: pt.func.isRequired,
};
